var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartGray11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.12526C0 14.081 4.623 17.2543 8.0063 20.0956C9.2 21.0974 10.35 22.0417 11.5 22.0417C12.65 22.0417 13.8 21.0986 14.9937 20.0944C18.3781 17.2555 23 14.081 23 8.12649C23 2.17071 16.675 -2.05332 11.5 3.67343C6.325 -2.05454 0 2.16949 0 8.12526Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGray11);
export default __webpack_public_path__ + "static/media/heart-gray-1-1.55d89d144930cce8362b0d2357829577.svg";
export { ForwardRef as ReactComponent };